import { render, staticRenderFns } from "./IcoExclamationTriangle.vue?vue&type=template&id=50638fdd"
import script from "./IcoExclamationTriangle.vue?vue&type=script&lang=js"
export * from "./IcoExclamationTriangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports